import Product from "../../../../@types/Product";

/*
 id 1-100
*/
const AccessoriesESeries: Product[] = [
    {
        id: 1,
        name: 'Front & Rear Cup Holders',
        sku: '1',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/cupholders.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        name: 'Premium Steering Wheel',
        sku: '2',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/steering-wheel.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 3,
        name: 'LED Display',
        sku: '3',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/accessories/led-dash.png`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 4,
        name: 'Color Accented Seating',
        sku: '4',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/accessories/color-accented-seats.png`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 5,
        name: '12" Aluminum Wheels',
        sku: '5',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/accessories/aluminum-wheels.png`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 6,
        name: 'Onboard Charger',
        sku: '6',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/onboard-charger.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 7,
        name: 'Rear Seat with Integrated Storage & Grab Bar',
        sku: '7',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/rear-seat-storage.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 8,
        name: 'Side Mirrors',
        sku: '8',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/mirrors.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 9,
        name: 'Roof with Integrated Grab Handles',
        sku: '9',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/reddot-versa-roof.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 10,
        name: 'Clear Foldable Windshield',
        sku: '10',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/windshield-clear.png`,
        price: 0.00,
        retailPrice: 0.00,
    },
];

/*
 id 101 - 200
*/
const AccessoriesESeriesLifted: Product[] = [
    ...AccessoriesESeries,
    {
        id: 101,
        name: 'Fender Flares',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/accessories/fender-flares.jpg`,
        sku: '101',
        price: 0,
        retailPrice: 0.00,
    },
];

/*
 id 201 - 300
*/
const AccessoriesESeriesOptional: Product[] = [];

/*
 id 301 - 400
*/
const AccessoriesESeriesOptionalNonLifted: Product[] = [];

/*
 id 401 - 500
*/
const AccessoriesXSeries: Product[] = [
    {
        id: 401,
        name: 'Front & Rear Cup Holders',
        sku: '401',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/cupholders.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 402,
        name: 'Premium Steering Wheel',
        sku: '402',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/steering-wheel.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 403,
        name: 'Multi-Color LED Lighting Kit',
        sku: '403',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/led-lighting-kit.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 404,
        name: '4" Built In Speakers',
        sku: '404',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/speakers.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 405,
        name: 'Dual Wireless Phone Chargers',
        sku: '405',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/phone-charger.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 406,
        name: '10" Display',
        sku: '406',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/led-display.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 407,
        name: 'Rearview Camera',
        sku: '407',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/rear-camera.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 408,
        name: 'Lockable Glove Box',
        sku: '408',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/glovebox.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 409,
        name: 'Onboard Charger',
        sku: '409',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/onboard-charger.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 410,
        name: 'Branded Liner Mats',
        sku: '410',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/liner-mats.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 411,
        name: 'Grab Bar',
        sku: '411',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/grab-bar.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 412,
        name: 'Rear Seat Storage',
        sku: '412',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/rear-seat-storage.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 413,
        name: 'Side & Center Mirrors',
        sku: '413',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/mirrors.jpg`,
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 414,
        name: 'Overhead Storage',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/overhead-storage.jpg`,
        sku: '414',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 415,
        name: 'RedDot Versa Triple Track Roof',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/reddot-versa-roof.jpg`,
        sku: '415',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 416,
        name: 'Clear Foldable Windshield',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/windshield-clear.png`,
        sku: '416',
        price: 0.00,
        retailPrice: 0.00,
    }
];

/*
 id 501 - 600
*/
const AccessoriesXSeriesLifted: Product[] = [
    ...AccessoriesXSeries,
    {
        id: 501,
        name: 'Fender Flares',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/fender-flares.png`,
        sku: '501',
        price: 0,
        retailPrice: 0.00,
    },
    {
        id: 502,
        name: 'Brush Guard',
        sku: '502',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/brush-guard.jpg`,
        price: 0,
        retailPrice: 0.00,
    },
];

const AccessoriesXSeriesOptionalNonLifted: Product[] = [
    {
        id: 501,
        name: 'Fender Flares',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/fender-flares.png`,
        sku: '501',
        refId: 'NL',
        price: 0,
        retailPrice: 290,
    },
    {
        id: 502,
        name: 'Brush Guard',
        sku: '502',
        refId: 'NL',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/brush-guard.jpg`,
        price: 0,
        retailPrice: 420,
    },
]

/*
 id 601 - 700
*/
const AccessoriesXSeriesOptional: Product[] = [
    {
        id: 601,
        name: 'Nerf Bars',
        sku: '601',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/nerf-bars.jpg`,
        price: 495,
        retailPrice: 495.00,
    },
    {
        id: 602,
        name: 'Side Step',
        sku: '602',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/side-step.jpg`,
        price: 85,
        retailPrice: 85.00,
    },
    {
        id: 603,
        name: 'Custom Fit Enclosure',
        sku: '603',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/enclosure.jpg`,
        price: 1340,
        retailPrice: 1340.00,
    },
    {
        id: 604,
        name: 'LED Light Bar - 7.5',
        sku: '604',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/lightbar7.jpg`,
        price: 100,
        retailPrice: 100.00,
    },
    {
        id: 605,
        name: 'LED Light Bar - 21.5',
        sku: '605',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/lightbar21.jpg`,
        price: 175,
        retailPrice: 175.00,
    },
    {
        id: 606,
        name: 'Bazooka Sound Bar - 24"',
        sku: '606',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/bazooka24.jpg`,
        price: 620,
        retailPrice: 620.00,
    },
    {
        id: 608,
        name: 'Bazooka Sound Bar - 36"',
        sku: '608',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/bazooka36.jpg`,
        price: 800,
        retailPrice: 800.00,
    },
    {
        id: 609,
        name: 'Golf Bag Holder',
        sku: '609',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/golfbar-holder.jpg`,
        price: 220,
        retailPrice: 220.00,
    },
    {
        id: 610,
        name: 'Cooler Box',
        sku: '610',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/cooler-box.jpg`,
        price: 100,
        retailPrice: 100.00,
    },
];


/*
 id 701 - 800
*/
const AccessoriesXSeriesOptionalLifted: Product[] = [
    ...AccessoriesXSeriesOptional
];


/*
 id 1001 - 1100
*/

const AccessoriesOptionalXtremeMats: Product[] = [
    {
        id: 1001,
        name: 'Xtreme Mat Black (Front)',
        sku: '1001',
        refId: [
            'GY03',
            'WH04',
            'BK03',
            'GN06',
            'YE02',
            'OR05',
            'VL03'
        ],
        price: 0,
        retailPrice: 115.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-203_Xtreme_Mats-Black_150px.jpg`,
    },
    {
        id: 1002,
        name: 'Xtreme Mat Black (Rear)',
        sku: '1002',
        refId: [
            'GY03',
            'WH04',
            'BK03',
            'GN06',
            'YE02',
            'OR05',
            'VL03'
        ],
        price: 0,
        retailPrice: 80.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-203_Xtreme_Mats-Black-Close_Up_150px.jpg`,
    },
    {
        id: 1003,
        name: 'Xtreme Mat Cherry Red (Front)',
        sku: '1003',
        refId: 'RD02',
        price: 0,
        retailPrice: 115.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-208_Xtreme_Mats-Cherry_Red_150px.jpg`,
    },
    {
        id: 1004,
        name: 'Xtreme Mat Cherry Red (Rear)',
        sku: '1004',
        refId: 'RD02',
        price: 0,
        retailPrice: 80.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-208_Xtreme_Mats-Cherry_Red-Close_Up_150px.jpg`,
    },
    {
        id: 1005,
        name: 'Xtreme Mat Rosso Red (Front)',
        sku: '1005',
        refId: 'RD06',
        price: 0,
        retailPrice: 115.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-204_Xtreme_Mats-Rosso_Red_150px.png`,
    },
    {
        id: 1006,
        name: 'Xtreme Mat Rosso Red (Rear)',
        sku: '1006',
        refId: 'RD06',
        price: 0,
        retailPrice: 80.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-204_Xtreme_Mats-Rosso_Red-Close_Up_150px.jpg`,
    },
    {
        id: 1007,
        name: 'Xtreme Mat Sea Storm (Front)',
        sku: '1007',
        refId: 'BG02P',
        price: 0,
        retailPrice: 115.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-206_Xtreme_Mats-Sea_Storm_150px-150x150.jpg`,
    },
    {
        id: 1008,
        name: 'Xtreme Mat Sea Storm (Rear)',
        sku: '1008',
        refId: 'BG02P',
        price: 0,
        retailPrice: 80.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-206_Xtreme_Mats-Sea_Storm-Close_Up_150px.jpg`,
    },
    {
        id: 1009,
        name: 'Xtreme Mat Bolt Blue (Front)',
        sku: '1009',
        refId: 'BL09',
        price: 0,
        retailPrice: 115.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-215_Xtreme_Mats-Bolt_Blue_150px.jpg`,
    },
    {
        id: 1010,
        name: 'Xtreme Mat Bolt Blue (Rear)',
        sku: '1010',
        refId: 'BL09',
        price: 0,
        retailPrice: 80.00,
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/accessories/03-215_Xtreme_Mats-Bolt_Blue-Close_Up_150px.jpg`,
    },
]

export { 
    AccessoriesESeries, 
    AccessoriesESeriesLifted, 
    AccessoriesESeriesOptional, 
    AccessoriesESeriesOptionalNonLifted, 
    AccessoriesXSeries,
    AccessoriesXSeriesLifted,
    AccessoriesXSeriesOptional,
    AccessoriesXSeriesOptionalNonLifted,
    AccessoriesXSeriesOptionalLifted,
    AccessoriesOptionalXtremeMats 
};